// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/font-awesome.css
// module id = 2015
// module chunks = 0